




import { Vue } from 'vue-property-decorator';
import translator from './Translator';

export default Vue.extend({
  props: {
    message: String,
  },
  computed: {
    output(): string {
      return translator(this.message);
    },
  },
});
